var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NcMultiselect',{attrs:{"value":_vm.currentValue,"loading":_vm.status.isLoading && _vm.groups.length === 0,"options":_vm.groups,"multiple":false,"label":"displayname","track-by":"id"},on:{"search-change":_vm.searchAsync,"input":(value) => _vm.$emit('input', value.id)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }